// src/utils/InactivityHandler.js
import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const useInactivityHandler = (timeout = 180000) => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      localStorage.removeItem('token'); 
      navigate('/signin'); 
    }, timeout);
  }, [navigate, timeout]);

  useEffect(() => {
    resetTimer(); 
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keypress', resetTimer);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keypress', resetTimer);
    };
  }, [resetTimer]);

  return null;
};

export default useInactivityHandler;
